import { AxiosRequest } from 'src/lib/axios/Axios';
import { CreatePublicationPayload, CreatePublicationResult } from './types';

export const createPublication = async (
  payload: CreatePublicationPayload,
): Promise<CreatePublicationResult> => {
  const response = await AxiosRequest.post<CreatePublicationResult>('/publications', payload);
  return response.data;
};
